import React, { lazy } from 'react';

const SearchReportsItems = lazy(() => import('./components/SearchReportsItems'));
const Downloads = lazy(() => import('./components/Downloads'));
const BostonMayoralElection = lazy(() => import('./BostonMayoralElection'));
const GovernorElection = lazy(() => import('./GovernorElection'));
const BallotQuestionsElection = lazy(() => import('./BallotQuestionsElection'));

const routes = [
  {
    path: '/Data/SearchItems',
    renderer: (params = {}): JSX.Element => <SearchReportsItems {...params} />,
  },
  {
    path: '/Reports/SearchItems',
    renderer: (params = {}): JSX.Element => <SearchReportsItems {...params} />,
  },
  {
    path: '/Data/Downloads',
    renderer: (params = {}): JSX.Element => <Downloads {...params} />,
  },
  {
    path: '/Data/BostonMayoralElection',
    renderer: (params = {}): JSX.Element => <BostonMayoralElection {...params} />,
  },
  {
    path: '/Data/GovernorElection',
    renderer: (params = {}): JSX.Element => <GovernorElection {...params} />,
  },
  {
    path: '/Data/BallotQuestionsElection',
    renderer: (params = {}): JSX.Element => <BallotQuestionsElection {...params} />,
  }
];

export default routes;
